export { GlobalHandlers } from './globalhandlers';
export { TryCatch } from './trycatch';
export { Breadcrumbs } from './breadcrumbs';
export { LinkedErrors } from './linkederrors';
export { UserAgent } from './useragent';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/@sentry/browser/esm/integrations/index.js
// module id = ../../../../@sentry/browser/esm/integrations/index.js
// module chunks = 3